<template>
    <div class="cruise-stappen whitebg border2 stap1 width100 marginbottom15">
        <div class="stap-header lichtblauwbg width100">
            <div
                style="margin-bottom: 0;"
                class="stap-header width60 floatleft fontsize14 bold midblauw padding10 uppercase"
            >
                Stap {{ this.currentStep }}: Kies een datum
            </div>
            <div class="width30 floatright marginright10">
                <a
                    v-on:click="prevDeparture"
                    class="button smallbutton midblauwbg floatleft width45 rounded"
                >
                    &lt; Eerder
                </a>
                <a
                    v-on:click="nextDeparture"
                    class="button smallbutton midblauwbg floatright width45 rounded"
                >
                    Later &gt;
                </a>
            </div>
        </div>
        <div class="clear"></div>

        <div v-if="cruiseID" class="stap-content width100 overflowhidden">
            <div class="hut floatleft">
                <li class="datum width100 ultralichtblauwbg">
                    <!-- empty cell -->
                </li>

                <li
                    v-for="(cabinType, cabinTypeIndex) in cabinTypes.collection"
                    :class="{
                        selected: false,
                        ultralichtblauwbg: !isEven(cabinTypeIndex),
                    }"
                    class="datum width100"
                    style="line-height: 44px"
                >
                    <span class="paddingleft10">
                        {{ cabinType.text }}
                    </span>
                </li>
            </div>

            <div class="cijfers floatleft">
                <div class="ratesOverviewScroll">
                    <!-- BORDER HIGHLIGHT -->
                    <div
                        v-for="(departure, departureIndex) in departures.list"
                        :key="departure + departureIndex"
                        class="bedrag textcenter"
                        :class="{
                            highlight: isHighlighted(departure.cruiseID),
                        }"
                    >
                        <ul class="diffDate">
                            <!-- DATE HIGHLIGHT-->
                            <li
                                :class="{
                                    selected: isHighlighted(departure.cruiseID),
                                }"
                                class="datum width100 ultralichtblauwbg"
                            >
                                <span class="displaynone_mobile">
                                    {{
                                        daysOfWeek[
                                            moment(
                                                departure.departureDate
                                            ).isoWeekday() - 1
                                        ]
                                    }}
                                </span>
                                <br />
                                {{
                                    moment(departure.departureDate).format('ll')
                                }}
                            </li>

                            <!-- TABLE CONTENT -->
                            <transition-group name="drop" appear>
                                <li
                                    v-for="(cabinType,
                                    cabinTypeIndex) in cabinTypes.collection"
                                    :key="cabinTypeIndex + cabinType"
                                    v-on:click="
                                        setActiveDeparture(
                                            departure.cruiseID,
                                            departureIndex,
                                            departure.departureDate,
                                            cabinTypeIndex,
                                            cabinType.text
                                        )
                                    "
                                    :class="{
                                        ultralichtblauwbg: !isEven(
                                            cabinTypeIndex
                                        ),
                                        selected: isActiveDeparture(
                                            departure.cruiseID,
                                            cabinTypeIndex,
                                            cabinType.text
                                        ),
                                    }"
                                    class="odd date width100 paddingtop10 paddingbottom10 hover"
                                >
                                    <Rate
                                        :rate="
                                            lowestRate(
                                                departure.cruiseID,
                                                cabinType.text
                                            )
                                        "
                                    />
                                </li>
                            </transition-group>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Rate from './Rate.vue'

export default {
    name: 'RatesOverview',
    data: function() {
        return {
            selectedDeparture: 0,
            cabinIndex: null,
            selectedCabinType: this.$route.params.hutType
                ? this.$route.params.hutType
                : 'Binnenhut',
        }
    },
    components: {
        Rate,
    },
    props: {
        cruiseID: Number,
        currentStep: Number,
    },
    methods: {
        setActiveDeparture(
            cruiseID,
            departureIndex,
            date,
            cabinTypeIndex = 0,
            name = this.selectedCabinType
        ) {
            date = this.moment(date).format('DD-MM-YYYY')
            const rateID = this.lowestRate(cruiseID, name).rateID
            const selectedCabinTypeIndex = cabinTypeIndex
                ? cabinTypeIndex
                : this.selectedCabin

            //Save selection to store
            this.$store.dispatch('highlightDeparture', {
                cruiseID: cruiseID,
                departureIndex: departureIndex,
                cabinIndex: selectedCabinTypeIndex,
                rateID,
                route: this.$route,
                date,
            })

            //Make view scroll to selected cruise
            if (departureIndex && this.selectedDeparture !== departureIndex) {
                this.scrollToActiveDeparture()
            }

            this.selectedCabin = selectedCabinTypeIndex
            this.selectedDeparture = departureIndex
            this.selectedCabinType = name
        },

        isHighlighted: function(cruiseID) {
            return parseInt(this.highlightedRate.cruiseID) === cruiseID
        },

        lowestRate(cruiseID, cabinTypeName) {
            const rates = this.departures.collection[cruiseID][cabinTypeName]
            if (typeof rates === 'undefined') {
                return {}
            }
            const lowestRate = rates[0]
            return lowestRate
        },

        nextDeparture: function() {
            this.highlightedRate.departureIndex += 1
            if (this.highlightedRate.departureIndex > this.departureCount) {
                this.highlightedRate.departureIndex = 0
            }

            let cruiseID = this.departures.list[
                this.highlightedRate.departureIndex
            ].cruiseID

            let depDate = this.departures.list[
                this.highlightedRate.departureIndex
            ].departureDate

            this.setActiveDeparture(
                cruiseID,
                this.highlightedRate.departureIndex,
                depDate
            )
        },

        prevDeparture: function() {
            this.highlightedRate.departureIndex -= 1
            if (this.highlightedRate.departureIndex < 0) {
                this.highlightedRate.departureIndex = this.departureCount
            }

            let cruiseID = this.departures.list[
                this.highlightedRate.departureIndex
            ].cruiseID

            let depDate = this.departures.list[
                this.highlightedRate.departureIndex
            ].departureDate

            this.setActiveDeparture(
                cruiseID,
                this.highlightedRate.departureIndex,
                depDate
            )
        },

        scrollToActiveDeparture: function() {
            this.$nextTick(function() {
                const scrollbar = '.ratesOverviewScroll'
                const elWidth = $('.diffDate').outerWidth(true)

                $(scrollbar)
                    .stop()
                    .animate(
                        {
                            scrollLeft:
                                this.highlightedRate.departureIndex * elWidth,
                        },
                        200
                    )
            })
        },

        isActiveDeparture: function(cruise, index, name) {
            return (
                parseInt(this.highlightedRate.cruiseID) === cruise &&
                this.selectedCabinType === name
            )
        },

        isEven: function(index) {
            return index % 2 === 0
        },
    },
    computed: {
        daysOfWeek: function() {
            let daysOfWeek = []
            this.$store.state.regionalDays.forEach(function(day) {
                daysOfWeek.push(day.regionalName)
            })

            return daysOfWeek
        },

        cabinChanged: function() {
            return this.$store.state.cabinChanged
        },

        highlightedRate: function() {
            return this.$store.state.highlightedRate
        },

        departures: function() {
            return this.$store.state.departures
        },

        cabinTypes: function() {
            return this.$store.state.cabinTypes
        },

        departureCount: function() {
            return Object.keys(this.departures.list).length - 1
        },

        minMaxRate: function() {
            let maxRate = { prijs: 0 }
            let minRate = { prijs: 999999 }
            let cruiseID = 0
            let cabinTypeName = ''
            let rateIndex = ''

            for (cruiseID in this.departures.collection) {
                let departure = this.departures.collection[cruiseID]
                for (cabinTypeName in departure) {
                    let cabinTypes = departure[cabinTypeName]
                    for (rateIndex in cabinTypes) {
                        let rate = cabinTypes[rateIndex]
                        let prijs = parseInt(rate.prijs)

                        if (maxRate.prijs < prijs) {
                            maxRate = rate
                        }

                        if (minRate.prijs > prijs) {
                            minRate = rate
                        }
                    }
                }
            }
            return {
                maxRate: maxRate,
                minRate: minRate,
            }
        },
    },
    updated: function() {
        this.scrollToActiveDeparture()
    },
}
</script>

<style scoped>
.ratesOverviewScroll {
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
}

.selected {
    font-weight: bold;
    color: white !important;
}

.hut ul,
.hut ul li,
.cijfers ul,
.cijfers ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.oddwhite {
    background-color: white;
}
.odd,
.even,
.datum {
    clear: both;
    display: block;
    min-height: 44px !important;

    font-weight: normal !important;
}

.datum {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}

.bedrag {
    cursor: pointer;
}

.bedrag .selected {
    background-color: #37b5d3 !important;
    color: #fff !important;
}

.hover:hover {
    background-color: #37b5d3;
    color: #fff !important;
}
</style>
